import { __ } from '@wordpress/i18n';

export const CYCLE_LABEL = {
    annual: __('Annual', 'jeg-elementor-kit'),
    monthly: __('Monthly', 'jeg-elementor-kit'),
    lifetime: __('Lifetime', 'jeg-elementor-kit'),
};

export const PLAN_CARD_LABELS = {
    basic: __('Basic', 'jeg-elementor-kit'),
    professional: __('Professional', 'jeg-elementor-kit'),
    agency: __('Agency', 'jeg-elementor-kit'),
};

export const FEATURE_BASE = [
    __('100+ Prebuilt Demo', 'jeg-elementor-kit'),
    __('Priority Support', 'jeg-elementor-kit'),
    __('Lifetime Update', 'jeg-elementor-kit'),
    __('Multi Language & Translation Support', 'jeg-elementor-kit'),
];

export const FEATURE_GROUPS = [
    {
        label: __('Advance Multipurpose Widget', 'jeg-elementor-kit'),
        items: [
            __('Interactive Widgets', 'jeg-elementor-kit'),
            __('Content Widgets', 'jeg-elementor-kit'),
            __('Multimedia Widgets', 'jeg-elementor-kit'),
            __('Chart Widgets', 'jeg-elementor-kit'),
            __('Marketing Widgets', 'jeg-elementor-kit'),
            __('Social Widgets', 'jeg-elementor-kit'),
            __('Navigation Widgets', 'jeg-elementor-kit'),
            __('Post Widget', 'jeg-elementor-kit'),
            __('Social Widget', 'jeg-elementor-kit'),
        ],
    },
    {
        label: __('Woocommerce Integration', 'jeg-elementor-kit'),
        items: [
            __('Product Grid Widget', 'jeg-elementor-kit'),
            __('Product Carousel Widget', 'jeg-elementor-kit'),
            __('Single Product Widgets', 'jeg-elementor-kit'),
            __('Cart Widgets', 'jeg-elementor-kit'),
            __('Checkout Widgets', 'jeg-elementor-kit'),
            __('Account Page Widgets', 'jeg-elementor-kit'),
            __('Product Archive Widgets', 'jeg-elementor-kit'),
            __('Product Filter', 'jeg-elementor-kit'),
        ],
    },
    {
        label: __('Advance Builder', 'jeg-elementor-kit'),
        items: [
            __('Megamenu Builder', 'jeg-elementor-kit'),
            __('Popup Builder', 'jeg-elementor-kit'),
        ],
    },
    {
        label: __('Custom Templates', 'jeg-elementor-kit'),
        items: [
            __('Custom Header', 'jeg-elementor-kit'),
            __('Custom Footer', 'jeg-elementor-kit'),
            __('Custom 404 Page', 'jeg-elementor-kit'),
            __('Custom Single Post', 'jeg-elementor-kit'),
            __('Custom Single Product', 'jeg-elementor-kit'),
            __('Custom Archive', 'jeg-elementor-kit'),
        ],
    },
    {
        label: __('Advance Animations & Styling', 'jeg-elementor-kit'),
        items: [
            __('Background Motion Effects', 'jeg-elementor-kit'),
            __('Mouse Effects', 'jeg-elementor-kit'),
            __('Parallax', 'jeg-elementor-kit'),
            __('Blend Mode', 'jeg-elementor-kit'),
            __('Custom Cursor', 'jeg-elementor-kit'),
        ],
    },
];

export const FAQ_DATA = [
    {
        q: __('Can I cancel my account at any time?', 'jeg-elementor-kit'),
        a: __("Yes, if you ever decide that Jeg Kit isn't the best plugin for your business, simply cancel your account from your Account panel.", 'jeg-elementor-kit'),
    },
    {
        q: __('Do you offer refunds?', 'jeg-elementor-kit'),
        a: __("We offer a 100% satisfaction guarantee, no questions asked. If you're not satisfied within 14 days, we'll promptly issue a full refund.", 'jeg-elementor-kit'),
    },
    {
        q: __("What's the time span for your contracts?", 'jeg-elementor-kit'),
        a: __('All plans are annual subscriptions. There are no long-term lock-ins — you can cancel at any time.', 'jeg-elementor-kit'),
    },
    {
        q: __('Do you offer support if I need help?', 'jeg-elementor-kit'),
        a: __('Yes! All plans include priority support from our team.', 'jeg-elementor-kit'),
    },
    {
        q: __('Can I change my plan later on?', 'jeg-elementor-kit'),
        a: __('Absolutely. You can upgrade or switch plans at any time from your account dashboard.', 'jeg-elementor-kit'),
    },
    {
        q: __('What payment methods are accepted?', 'jeg-elementor-kit'),
        a: __('We accept Visa, Mastercard, American Express, JCB, and PayPal.', 'jeg-elementor-kit'),
    },
    {
        q: __('I have other pre-sale questions, can you help?', 'jeg-elementor-kit'),
        a: __("Of course! Reach out to our support team and we'll be happy to help.", 'jeg-elementor-kit'),
    },
];
